import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"
import { t, getLocale } from "@/i18n";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatTime(ts) {
  if (!ts) return '';
  return new Date(ts).toLocaleTimeString(getLocale(), { hour: '2-digit', minute: '2-digit', hour12: false });
}

export function getStatusStyle(pct) {
  if (pct >= 90) return { bar: 'bg-green-500', text: 'text-green-700', bg: 'bg-green-50', label: t('status.ok') };
  if (pct >= 70) return { bar: 'bg-yellow-500', text: 'text-yellow-700', bg: 'bg-yellow-50', label: t('status.warning') };
  return { bar: 'bg-red-500', text: 'text-red-700', bg: 'bg-red-50', label: t('status.problem') };
}
